export default {
    coagulation: {
        title: 'Coagulation',
        description: 'Coagulation is the process in which a blood clot is formed, stopping a bleed. Coagulation happens in two ways: first, primary hemostasis leads to a platelet plug that seals the injury and then, secondary hemostasis, the coagulation cascade, leads to the formation of a fibrin mesh that reinforces the platelet plug, forming a strong, durable clot.'
    },
    bleed_bleedingEpisodes: {
        title: 'Bleed/Bleeding Episodes',
        description: 'Everyone has experienced a bleed when they’ve scraped their knee or gotten a paper cut. Soon after a minor injury, some blood flows, and then a blood clot forms, stopping the bleeding. <br/>People with bleeding disorders, like hemophilia and von Willebrand disease, have more frequent bleeding episodes that can last longer than other people, and can happen on their skin, in their joints, muscles, and elsewhere in the body.'
    },
    platelets: {
        title: 'Platelets',
        description: 'Small cell fragments that circulate in the blood. When an injury happens, platelets change shape and stick to the injury, sealing it. These activated platelets release signals attracting more platelets to the site of injury, sealing it from blood loss. This process is called primary hemostasis.'
    },
    bleedingDisorder: {
        title: 'Bleeding Disorders',
        description: 'A group of disorders in which people are unable to form a proper blood clot. In general, they have extended bleeding after injury, surgery, trauma, or menstruation, and may experience spontaneous bleeds.'
    },
    plateletPlug: {
        title: 'Platelet Plug',
        description: 'When an injury happens, platelets circulating in the blood become activated, changing shape, adhering to the site of injury, and attracting more platelets to the site of injury. This collection of platelets is called a platelet plug, which can seal small injuries to stop blood loss.'
    },
    bloodClot: {
        title: 'Blood Clot',
        description: 'A blood clot is formed to stop blood loss caused by an injury and prevent re-bleeding. A blood clot is made of a platelet plug, reinforced with insoluble fibrin mesh.'
    },
    coagulationCascade: {
        title: 'Coagulation Cascade',
        description: 'The coagulation cascade is a part of secondary hemostasis. The cascade includes an intrinsic pathway and extrinsic pathway which both lead to the common pathway to fibrin formation. The coagulation cascade works like a series of gears—each coagulation factor must activate the next until the clot is formed. If any factor is missing from the coagulation cascade, the clot won’t form correctly.'
    },
    intrinsicPathway: {
        title: 'Intrinsic Pathway',
        description: 'The intrinsic pathway is activated when blood hits the site of injury, activating factor XII, eventually leading to the common pathway.'
    },
    extrinsicPathway: {
        title: 'Extrinsic Pathway',
        description: 'The extrinsic pathway is activated when blood leaves the blood vessel, activating factor VII, and leading to the common pathway.'
    },
    fibrin: {
        title: 'Fibrin',
        description: 'The coagulation cascade leads to a fibrin mesh, which wraps around the platelet plug, stabilizing it to create a strong, durable clot. Fibrin is insoluble in blood, meaning it will keep an injury sealed and keep it from re-bleeding.'
    },
    factor: {
        title: 'Factor',
        description: 'Blood coagulation factors or clotting factors circulate in the blood in an inactivated form. When an injury happens, the factors are activated and go through the coagulation cascade. If a factor is missing, defective, or there is too little of it in the blood, the coagulation cascade won’t work correctly, leading to a bleeding disorder.'
    },
    replacementFactor: {
        title: 'Replacement Factor',
        description: 'Treatment for people lacking a clotting factor usually involves replacing the missing or deficient factor. People with hemophilia A need replacement factor VIII. People with hemophilia B need replacement factor IX.'
    },
    geneticDisorder: {
        title: 'Genetic Disorder',
        description: 'Many bleeding disorders are genetic, meaning they are passed down by parents.'
    },
    commonPathway: {
        title: 'Common Pathway',
        description: 'During secondary hemostasis, the intrinsic and extrinsic pathways of the coagulation cascade both lead to the common pathway to fibrin formation. The common pathway starts at the activation of factor X, leading to a thrombin burst, and the eventual formation of a fibrin mesh.'
    },
    thrombinBurst: {
        title: 'Thrombin Burst',
        description: 'The formation of fibrin is the most important step in the coagulation cascade. Thrombin converts fibrinogen to fibrin, strengthening the clot. The sooner the thrombin burst happens, the less damage a bleed can cause.'
    },
    hemostasis: {
        title: 'Hemostasis',
        description: 'The process of stopping a bleed at the site of injury. During primary hemostasis, platelets become sticky and create a platelet plug to stop the bleeding. During secondary hemostasis, the coagulation cascade produces a fibrin mesh that wraps around the plug, forming a strong, durable clot.'
    },
    immuneSystem: {
        title: 'Immune System',
        description: 'Each body has an army, called an immune system, that fights off foreign objects like germs and viruses that try to attack it. When the body recognizes something foreign, it produces antibodies that bind and disarm these “invaders.”'
    },
    antibodies_inhibitors: {
        title: 'Antibodies/Inhibitors',
        description: 'Antibodies are produced by the immune system to bind to and disarm any foreign objects that try to attack the body. Sometimes, the immune system mistakes replacement factor for a foreign object and makes antibodies to bind and disarm them, stopping or inhibiting the replacement factor from working.'
    },
    highTiterInhibitor: {
        title: 'High-titer Inhibitor',
        description: 'The most common way to measure inhibitors is with the Bethesda Unit assay. A score greater than 5 Bethesda units means that the body has a strong response against the replacement factor. This is called having a high-titer inhibitor.'
    },
    lowTiterInhibitor: {
        title: 'Low-titer Inhibitor',
        description: 'The most common way to measure inhibitors is with the Bethesda Unit assay. A score less than 5 Bethesda units means that the body does not have a strong response against the replacement factor. This is called having a low-titer inhibitor.'
    }
}




// WEBPACK FOOTER //
// ./src/js/text-content/glossary-content.js